<template>
  <div class="app-container">
    <div v-if="user">
      <el-row :gutter="20">
        <el-col :span="6" :xs="24"><user-card :user="user" /></el-col>

        <el-col :span="18" :xs="24">
          <el-card>
            <el-tabs v-model="activeTab">
              <el-tab-pane label="个人信息" name="activity"><activity :user="user" /></el-tab-pane>
              <el-tab-pane label="修改密码" name="timeline"><timeline /></el-tab-pane>
              <!--              <el-tab-pane label="修改邮箱" name="account">
                <account :user="user" />
              </el-tab-pane> -->
            <!-- </el-tabs>
          </el-card>
        </el-col>
      </el-row> -->
    </el-tabs></el-card></el-col></el-row></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserCard from './components/UserCard';
import Activity from './components/Activity';
import Timeline from './components/Timeline';
// import getUserDetails from '@/api/user'

export default {
  name: 'Profile',
  components: { UserCard, Activity, Timeline},
  data() {
    return {
      activeTab: 'activity'
    };
  },
  computed: {
    ...mapGetters(['user', 'roles'])
  },
  // created() {
  //   getUserDetails().then(res => {
  //     console.log(res);
  //   })
  // }
};
</script>
